// extracted by mini-css-extract-plugin
export default {"contact-form-wrapper":"ContactForm_contact-form-wrapper__akEgS","contact-form":"ContactForm_contact-form__WrBF0","success-button":"ContactForm_success-button__jFGSa"};